import dayjs from 'dayjs';
import * as React from 'react';
import { isNullOrUndefined } from '@bimser/core';
import BCTimePicker from '../../../BCTimePicker';
import { IPropertyComponentProps } from '../../entities';

const defaultFormat = 'HH:mm:ss';
const defaultStyle: React.CSSProperties = { width: '100%' };

export default function TimePickerProperty(props: IPropertyComponentProps) {
	const getValue = () => {
		let value: dayjs.Dayjs = null;

		if (!props.value) {
			return value;
		}

		const isTime = props.item.options?.type === 'time';
		if (isTime && typeof props.value === 'string' && !dayjs(props.value).isValid()) {
			const [h, m, s] = props.value.split(':').map(Number);
			value = dayjs().set('h', h).set('m', m).set('s', s);
		} else {
			value = dayjs(props.value);
		}

		if (!value.isValid()) {
			value = null;
		}

		return value;
	};

	const onChange = (time: dayjs.Dayjs, timeString: string) => {
		if (props.customChangeEvent) {
			props.customChangeEvent(timeString);
			return;
		}

		if (props.item.options?.type === 'time') {
			if (time) {
				props.onValueChanged(
					props.item,
					`${time.get('h')}:${time.get('m')}:${time.get('s')}`
				);
			} else {
				props.onValueChanged(props.item, '');
			}
			return;
		}

		props.onValueChanged(props.item, timeString);
	};

	const calculateFormat = () => {
		const options = props.item.options;
		if (options) {
			if (typeof options === 'string') {
				return options;
			}
			const { use12Hours, format } = options;
			const existFormat = format || defaultFormat;
			if (use12Hours === true && existFormat.includes('HH')) {
				return existFormat.replace('HH', 'hh');
			} else if (use12Hours === false && existFormat.includes('hh')) {
				return existFormat.replace('hh', 'HH');
			}
			return existFormat;
		}
		return defaultFormat;
	};

	const disableHours = () => {
		const disableHours: Array<number> = new Array();
		if (!isNullOrUndefined(props.item.options?.minHour)) {
			for (let i = 0; i <= Number(props.item.options.minHour); i++) {
				disableHours.push(i);
			}
		}
		return disableHours;
	};

	const disableMinutes = () => {
		const disableMinutes: Array<number> = new Array();
		if (!isNullOrUndefined(props.item.options?.minMinute)) {
			for (let i = 0; i <= Number(props.item.options.minHour); i++) {
				disableMinutes.push(i);
			}
		}
		return disableMinutes;
	};

	const currentFormat = calculateFormat();
	const allowClear = props.item.options?.allowClear;

	return (
		<BCTimePicker
			value={getValue()}
			placeholder={props.item.label}
			onChange={onChange}
			use12Hours={props.item.options ? props.item.options.use12Hours : false}
			style={props.style || defaultStyle}
			disabled={props.item.disabled || props.item.readOnly}
			allowClear={!isNullOrUndefined(allowClear) ? allowClear : true}
			format={currentFormat}
			disabledHours={disableHours}
			disabledMinutes={disableMinutes}
			readOnly={props.readonly}
			size="small"
		/>
	);
}
